/**
 * Hyros Universal Script — from Hyros → Tracking (Meta attribution).
 *
 * Dashboard snippet appends the current page to ref_url. Set:
 *   REACT_APP_HYROS_UNIVERSAL_SCRIPT_PREFIX = full URL up to and including `ref_url=` (e.g. https://h.brain-event.com/v1/lst/universal-script?ph=...&tag=!clicked&ref_url=)
 *
 * Optional fallback: REACT_APP_HYROS_UNIVERSAL_SCRIPT_URL = static script src (no ref_url).
 * Do not duplicate in index.html or GTM unless you remove this injection.
 */
const HYROS_MARKER = 'data-brain-event-hyros';

export function injectHyrosUniversalScript() {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[${HYROS_MARKER}]`)) return;

  const prefix = (process.env.REACT_APP_HYROS_UNIVERSAL_SCRIPT_PREFIX || '').trim();
  const staticUrl = (process.env.REACT_APP_HYROS_UNIVERSAL_SCRIPT_URL || '').trim();

  let src = '';
  if (prefix) {
    src = prefix + encodeURI(document.URL);
  } else if (staticUrl) {
    src = staticUrl;
  }

  if (!src) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.setAttribute(HYROS_MARKER, '1');
  script.src = src;
  document.head.appendChild(script);
}
